var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_7042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.860462 13.2261C0.19495 13.8917 0.19495 14.9724 0.860462 15.638L9.37902 24.1565C10.0445 24.822 11.1253 24.822 11.7908 24.1565C12.4564 23.491 12.4564 22.4102 11.7908 21.7447L6.17391 16.1331H22.5083C23.4506 16.1331 24.212 15.3718 24.212 14.4294C24.212 13.487 23.4506 12.7257 22.5083 12.7257H6.17924L11.7855 7.11408C12.451 6.44856 12.451 5.36777 11.7855 4.70226C11.12 4.03675 10.0392 4.03675 9.3737 4.70226L0.855138 13.2208L0.860462 13.2261Z",
    fill: "#787676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_7042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.852,
    height: 27.2594,
    fill: "white",
    transform: "translate(0.360352 0.798828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.c65ea63f4227e26257c0a313d9c59a05.svg";
export { ForwardRef as ReactComponent };